import React from 'react';
import styles from './index.module.less';

const Error404 = (props): JSX.Element => {
  const goHome = () => {
    props.history.replace('/home');
  };

  return (
    <div className={styles.errorContainer}>
      <div className={styles.title}>404</div>
      <div>Sorry, the page you are trying to access does not exist</div>
      <div className={styles.button} onClick={goHome}>
        Return to Home Page
      </div>
    </div>
  );
};

export default Error404;
